import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useThunk } from "../../hooks/useThunk";
import { googleSignin } from "../../store";
import showToast from "../../utils/toastNotifications";
import { errorMessages } from "../../constants/frontendErrorMessages";
import { ThreeDots } from "react-loader-spinner";

export const WaitingPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParam] = useSearchParams();
  const [doGoogleSignup, isLoading, signupError] = useThunk(googleSignin);

  const error = searchParams.get("error");

  useEffect(() => {
    if (error) {
      showToast("error", errorMessages.LOGIN_FAILED);
      navigate("/signin", { replace: true });
      return;
    }
    const code = searchParams.get("code");
    const scope = searchParams.get("scope");

    if (code && scope) {
      doGoogleSignup({ code, scope }).then((result) => {
        if (result.success) {
          localStorage.setItem("token", result.response.data.token);
          showToast("success", result.response?.message);
          navigate("/", { replace: true });
        } else {
          showToast("error", result.error.message);
          navigate("/signin", { replace: true });
        }
      });
    } else {
      showToast("error", errorMessages.SOMETHING_WENT_WRONG);
      navigate("/signin");
    }
  }, [error, navigate]);

  return (
    <>
      <div className="w-full flex justify-center flex-col h-screen items-center">
        <div className="flex flex-col items-center p-[20px]">
          <ThreeDots color="#0020bd" size="medium" text="" textColor="" />
        </div>
        <h1 className="font-inter text-primary text-[20px]">
          Authenticating...
        </h1>
      </div>
    </>
  );
};
